'use client';

import { c as _c } from "react/compiler-runtime";
import { For, SegmentGroup } from '@chakra-ui/react';
import { forwardRef, useMemo } from 'react';
interface Item {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}
export interface SegmentedControlProps extends SegmentGroup.RootProps {
  items: Array<string | Item>;
}
function normalize(items: Array<string | Item>): Item[] {
  return items.map(item => {
    if (typeof item === 'string') return {
      value: item,
      label: item
    };
    return item;
  });
}
export const SegmentedControl = forwardRef<HTMLDivElement, SegmentedControlProps>(function SegmentedControl(props, ref) {
  const $ = _c(12);
  let items;
  let rest;
  if ($[0] !== props) {
    ({
      items,
      ...rest
    } = props);
    $[0] = props;
    $[1] = items;
    $[2] = rest;
  } else {
    items = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== items) {
    t0 = normalize(items);
    $[3] = items;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const data = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SegmentGroup.Indicator />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== data) {
    t2 = <For each={data}>{_temp}</For>;
    $[6] = data;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== ref || $[9] !== rest || $[10] !== t2) {
    t3 = <SegmentGroup.Root ref={ref} {...rest}>{t1}{t2}</SegmentGroup.Root>;
    $[8] = ref;
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
});
function _temp(item) {
  return <SegmentGroup.Item key={item.value} value={item.value} disabled={item.disabled}><SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText><SegmentGroup.ItemHiddenInput /></SegmentGroup.Item>;
}